module.exports = __webpack_public_path__ + "static/media/blueBankslip19.7ec13710.svg";